module.exports = __webpack_public_path__ + "static/media/7_Peace of mind_DE.78e18737.txt";